<template>
    <GenericTable :table-data="computedTableData"></GenericTable>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import GenericTable from '@/components/common/GenericTable.vue';
import { GenericTableOptions } from '@/types';
import { store } from '@/plugins/store';
import { ActionType } from '@/plugins/store/actions';

export default defineComponent({
    components: { GenericTable },
    props: {
        source: {
            type: String,
            default: null,
        },
        hiddenHeaders: {
            type: Array as () => string[],
            default: () => [],
        },
        hiddenFooters: {
            type: Array as () => string[],
            default: () => [],
        },
    },
    data() {
        return {
            tableData: null as null | GenericTableOptions,
        };
    },
    computed: {
        selectedSiteIds(): number[] {
            return store.getters.getSelectedSiteIds;
        },
        selectedPeriod(): string {
            return store.getters.getSelectedPeriod;
        },
        computedTableData(): GenericTableOptions | null {
            if (!this.tableData) {
                return null;
            }

            return {
                ...this.tableData,
                headers: this.tableData?.headers?.filter((h) => !this.hiddenHeaders.includes(h.value)),
                footers: this.tableData?.footers?.filter((f) => !this.hiddenFooters.includes(f.value)),
            };
        },
    },
    watch: {
        selectedSiteIds: {
            immediate: false,
            handler() {
                this.fetchData();
            },
        },
        selectedPeriod: {
            immediate: true,
            handler() {
                if (this.selectedSiteIds.length) {
                    this.fetchData();
                }
            },
        },
    },
    methods: {
        fetchData() {
            store.dispatch(ActionType.GetTable, { form: { url: this.$props.source } }).then((tableOptions: GenericTableOptions) => {
                this.tableData = tableOptions;
            });
        },
    },
});
</script>
